export default "__VITE_ASSET__CERAdMmk__"